"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.securityWatchers = exports.securityReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const authentication_1 = require("./authentication/index.js");
const invitations_1 = require("./invitations/index.js");
const oidc_configurations_1 = require("./oidc-configurations/index.js");
const switch_organization_1 = require("./switch-organization/index.js");
exports.securityReducers = (0, redux_1.combineReducers)({
    authentication: authentication_1.securityAuthenticationReducers,
    invitations: invitations_1.securityInvitationsReducers,
    oidcConfigurations: oidc_configurations_1.securityOidcConfigurationsReducers,
    switchOrganization: switch_organization_1.securitySwitchOrganizationReducers
});
exports.securityWatchers = (0, xuder_1.combineAllWatchers)([
    authentication_1.securityAuthenticationWatchers,
    invitations_1.securityInvitationsWatchers,
    oidc_configurations_1.securityOidcConfigurationsWatchers,
    switch_organization_1.securitySwitchOrganizationWatchers
]);
//# sourceMappingURL=index.js.map